import _implicitStylesheets from "./packageIcon.css";
import _implicitScopedStylesheets from "./packageIcon.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<svg${"a0:width"}${"a0:height"} viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg"${3}><title${3}>${"t2"}</title><g${"a3:id"} stroke="none" stroke-width="1" fill-rule="evenodd"${3}><g${"a4:id"}${3}><path fill-rule="evenodd" clip-rule="evenodd" d="M45.4459 30.5385H39.6729L37.2613 33.4615H45.1536V37.8462H18.8459V33.4615H26.6652L24.2536 30.5385H18.5536C17.0921 30.5385 15.9229 31.7077 15.9229 33.1692V47.3462C15.9229 48.5885 16.8729 49.5385 18.1152 49.5385H45.8844C47.1267 49.5385 48.0767 48.5885 48.0767 47.3462V33.1692C48.0767 31.7077 46.9075 30.5385 45.4459 30.5385ZM29.8075 15.5577V24.6923H24.7652C24.0344 24.6923 23.669 25.35 24.1075 25.7154L31.4152 34.7039C31.7075 34.9231 32.1459 34.9231 32.4382 34.7039L39.7459 25.7154C40.1844 25.2769 39.819 24.6923 39.0882 24.6923H34.1921V15.5577C34.1921 14.9731 33.6805 14.4615 33.0959 14.4615H30.9036C30.319 14.4615 29.8075 14.9731 29.8075 15.5577Z"${3}/></g></g></svg>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, gid: api_scoped_id, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    attrs: {
      "width": $cmp.width,
      "height": $cmp.height
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.alternativeText)), api_static_part(3, {
    attrs: {
      "id": api_scoped_id("AXPL-bootstrapper-icons-/-package")
    }
  }, null), api_static_part(4, {
    attrs: {
      "id": api_scoped_id("Icon")
    }
  }, null)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6jhjmftgsgd";
tmpl.legacyStylesheetToken = "appx-bootstrapperIcons_packageIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
